import { NavigateFunction } from 'react-router-dom';

import { ROUTE } from 'route/RouteEnums';
import { toAssignedProviderId } from 'utils/dropDownList';
import { getPatientDetailsAPI } from 'services/profileServices';

/**
 * MM-1161: opens self-scheduling on the right screen for this patient, deciding which one BEFORE
 * navigating rather than after the directory has already mounted.
 *
 * An established patient (primary provider assigned by staff) goes straight to that provider's
 * calendar - the Schedule Appointment directory is never rendered, not even briefly. A new patient
 * (no assigned provider, incl. MM-1136's "No assigned provider") goes to the directory as before.
 * If the patient lookup fails, falls back to the directory, which repeats the same check itself
 * (see SelfScheduling/index.tsx) - so a direct URL/refresh of the directory still redirects.
 *
 * The navigation state passed for the established-patient case is the same one the directory's
 * own redirect uses, so ProviderAvailability behaves identically either way (Back -> Dashboard).
 */
export const navigateToSelfScheduling = async (
  navigate: NavigateFunction,
  patientId?: number | null
): Promise<void> => {
  if (!patientId) {
    navigate(ROUTE.SELF_SCHEDULING);
    return;
  }
  let assignedProviderId: string | null = null;
  try {
    const response: any = await getPatientDetailsAPI(patientId);
    assignedProviderId = toAssignedProviderId(response?.data?.providerId);
  } catch {
    assignedProviderId = null;
  }
  if (assignedProviderId) {
    navigate(ROUTE.SELF_SCHEDULING_PROVIDER.replace(':providerId', String(assignedProviderId)), {
      state: {
        filters: { consultationTypes: ['Virtual'], locations: [] },
        searchText: '',
        directEntry: true,
      },
    });
    return;
  }
  navigate(ROUTE.SELF_SCHEDULING);
};
